export default __webpack_public_path__ + "static/media/briefcase-trans.e861687e.png";